// 파티 던전·거래소 공개 스위치(docs/PARTY-TRADE-PRD.md 0장). 운영 공개는 이 released 값 하나로만 바뀐다.
// 미리보기: 운영 호스트가 아닌 곳(개발 서버·로컬·workers.dev 진단)에서는 ?party=1 · ?market=1 쿼리로 연다(previewFlags와 같은 규칙).
// 서버 스위치(wrangler vars PARTY_NET·MARKET_NET)가 꺼져 있으면 클라가 열려도 /api/party/*·/api/market/*가 404라 연결이 안 된다.
import { previewQueryAllowedHere } from '../previewFlags';

export const PARTY_RELEASE = { released: false } as const;
export const MARKET_RELEASE = { released: false } as const;

/** 쿼리 읽기(브라우저 밖·실패면 빈 값) */
function query(name: string): string | null {
  try { return typeof location === 'undefined' ? null : new URLSearchParams(location.search).get(name); } catch { return null; }
}

/** 파티 창을 보여도 되는가 */
export function partyEnabledHere(): boolean {
  return PARTY_RELEASE.released || (query('party') === '1' && previewQueryAllowedHere());
}
/** 거래소 창을 보여도 되는가 */
export function marketEnabledHere(): boolean {
  return MARKET_RELEASE.released || (query('market') === '1' && previewQueryAllowedHere());
}
/** QA: 파티 서버 주소 덮어쓰기(?partyws=ws://…) — 운영 호스트에서는 무시 */
export function partyWsOverride(): string | undefined {
  const v = query('partyws');
  return v && previewQueryAllowedHere() && /^wss?:\/\/[^\s]+$/.test(v) ? v : undefined;
}
